import { DataObject } from "core/types/DataObject";

/**
 * core/types/CreditCard
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class CreditCard extends DataObject {
  /**
   * @type {number}
   */
  creditCardId = null;

  /**
   * @type {number}
   */
  personId = null;

  /**
   * @type {number}
   */
  subscriberId = null;

  /**
   * @type {number}
   */
  creditCardFlagId = null;

  /**
   * @type {string}
   */
  nameOnCard = null;

  /**
   * @type {number}
   */
  number = null;

  /**
   * @type {number}
   */
  cvv = null;

  /**
   * @type {number}
   */
  expYear = null;

  /**
   * @type {number}
   */
  expMonth = null;

  /**
   * @type {string|number}
   */
  dateCreated = null;

  /**
   * @type {string|number}
   */
  dateUpdated = null;

  /**
   * @param {number} creditCardId 
   * @param {number} personId 
   * @param {number} subscriberId 
   * @param {number} creditCardFlagId 
   * @param {string} nameOnCard 
   * @param {number} number 
   * @param {number} cvv 
   * @param {number} expYear 
   * @param {number} expMonth 
   * @param {string|number} dateCreated 
   * @param {string|number} dateUpdated 
   */
  constructor (
    creditCardId = null, 
    personId = null, 
    subscriberId = null, 
    creditCardFlagId = null, 
    nameOnCard = null, 
    number = null, 
    cvv = null, 
    expYear = null, 
    expMonth = null, 
    dateCreated = null, 
    dateUpdated = null
  ) {
    super();
    
    this.creditCardId = creditCardId || null;
    this.personId = personId || null;
    this.subscriberId = subscriberId || null;
    this.creditCardFlagId = creditCardFlagId || null;
    this.nameOnCard = nameOnCard || null;
    this.number = number || null;
    this.cvv = cvv || null;
    this.expYear = expYear || null;
    this.expMonth = expMonth || null;
    this.dateCreated = dateCreated || null;
    this.dateUpdated = dateUpdated || null;
  }
}
